import { CHECKOUT_ITEM_TYPE_INSURANCE } from 'constants/checkout'
import uuidV4 from 'lib/string/uuidV4Utils'
import { PRODUCT_ID_NO_PROTECTION } from 'constants/insurance'

export function generateInsuranceItem(
  options: {
    product?: Pick<App.InsuranceProduct, 'id' | 'type'>
    policyIds?: Array<string>
    customCoverage?: number
    flightJourneysKeys?: Array<string>
    hasFullBundleCoverage?: boolean
    bedbankRoomIds?: Array<string>
    isAccommodationBundle?: boolean
  } = {},
): App.Checkout.InsuranceItem {
  return {
    itemId: uuidV4(),
    transactionKey: uuidV4(),
    itemType: CHECKOUT_ITEM_TYPE_INSURANCE,
    productId: options.product?.id,
    policyIds: options.policyIds,
    insuranceType: options.product?.type,
    coverageAmount: options.customCoverage,
    flightJourneysKeys: options.flightJourneysKeys,
    hasFullBundleCoverage: options.hasFullBundleCoverage,
    bedbankRoomIds: options.bedbankRoomIds,
    isAccommodationBundle: options.isAccommodationBundle
  }
}

export function generateInsuranceNoProtectionItem(type: App.InsuranceType = 'insurance'): App.Checkout.InsuranceItem {
  return {
    itemId: uuidV4(),
    transactionKey: uuidV4(),
    itemType: CHECKOUT_ITEM_TYPE_INSURANCE,
    productId: PRODUCT_ID_NO_PROTECTION,
    insuranceType: type,
  }
}
